'use client';
import Link from 'next/link';
import React from 'react';
import styled from 'styled-components';

import Layout from '@Components/core/layout';
import { colors } from '@Components/design-system/color-v2';
import { BackgroundPalette } from '@Components/design-system/color-v2/types';
import Progress from '@Components/design-system/progress';
import { WhiteContainer } from '@Components/design-system/themes';
import HeaderWidgetNew from '@Components/header-widget-new';
import { getHeaderTitle } from '@Components/track-lab-order/util';
import useConsultationType from '@Modules/appointment/hooks/consultation-type';
import useComputeSteps from '@Modules/appointment/hooks/directional-engine/rules/compute-steps';
import { IQueryData } from '@Reducers/common';
import { useAppSelector } from '@Redux/hooks';
import useAnasRouter from '@Utils/hooks/anas-router';
import { Routes } from '@Utils/hooks/anas-router/routes';

const Page = ({ children }: { children: React.ReactNode }) => {
  const queryData: IQueryData = useAppSelector((state) => state.common.queryData);
  const { consultationType } = useConsultationType();
  const router = useAnasRouter();
  const steps = useComputeSteps();
  const currentStepIndex = steps.findIndex((step) => step.isActive);
  const goBack = () => {
    if (currentStepIndex > 0) {
      router.replace({
        route: Routes.APPOINTMENT,
        subRoute: steps[currentStepIndex - 1].label.toLowerCase().replaceAll(' ', '-'),
      });
    } else {
      router.back();
    }
  };

  return (
    <Layout
      fullHeight
      disableShadow
      screenBackgroundColor={colors.background[BackgroundPalette.LIGHT_2]}
      backgroundColor={colors.background[BackgroundPalette.LIGHT_1]}
      loaderStates={{}}>
      <MainContainer>
        <HeaderWidgetNew
          headerTitle={getHeaderTitle(queryData, consultationType)}
          iconName='chevron_left'
          goBack={goBack}>
          <WhiteContainer>
            <Progress type='number' steps={steps} />
          </WhiteContainer>
        </HeaderWidgetNew>
        {/* prefetch next route */}
        {currentStepIndex > 0 && !!steps[currentStepIndex + 1]?.label && (
          <Link
            className='hidden'
            href={`/${Routes.APPOINTMENT}/${steps[currentStepIndex + 1].label.toLowerCase().replaceAll(' ', '-')}`}
            prefetch
          />
        )}
        {children}
      </MainContainer>
    </Layout>
  );
};

export default Page;

const MainContainer = styled.main`
  background-color: ${colors.background.LIGHT_2};
`;
